import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AdminLayout from "./AdminLayout";
import PrivateRoute from "./PrivateRoute";
import constants from "../common/constants";

const Dashboard = LazyLoad(lazy(() => import("../pages/dashboard")));
const EmployeeManagement = LazyLoad(lazy(() => import("../pages/employee")));
const AgentManagement = LazyLoad(lazy(() => import("../pages/agent")));
const DatabaseManagement = LazyLoad(lazy(() => import("../pages/database")));
const ProgramManagement = LazyLoad(lazy(() => import("../pages/program")));
const AddEmployee = LazyLoad(lazy(() => import("../pages/employee/AddEmployee")));
const PreSalesManagement = LazyLoad(lazy(() => import("../pages/presales")));
const AddCampaign = LazyLoad(lazy(() => import("../pages/presales/AddCampaign")));
const EditCampaign = LazyLoad(lazy(() => import("../pages/program/EditCampaign")));
const DatabaseList = LazyLoad(lazy(() => import("../pages/agent/DatabaseList")));
const ViewCampaign = LazyLoad(lazy(() => import("../pages/presales/ViewCampaign")));
const ProgramDetail = LazyLoad(lazy(() => import("../pages/program/ProgramDetail")));
const AgentDetail = LazyLoad(lazy(() => import("../pages/agent/agentDetails")));
const DatabaseDetail = LazyLoad(lazy(() => import("../pages/agent/databaseDetail")));
const Program1 = LazyLoad(lazy(() => import("../pages/program1/index.js")));
const Report = LazyLoad(lazy(() => import("../pages/program/Report.js")));
const Invoice = LazyLoad(lazy(() => import("../pages/program/Invoice.js")));
const InvoicesTable = LazyLoad(lazy(() => import("../pages/agent/InvoicesTable.jsx")));
const AttendancePage = LazyLoad(lazy(() => import("../pages/attendance/AttendancePage.js")));
const AddDataToMasterDb = LazyLoad(lazy(() => import("../pages/database/AddDataToMasterDb.js")));
const CompanyManagement = LazyLoad(lazy(() => import("../pages/database/company/index.js")));
const ApprovalManagement = LazyLoad(lazy(() => import("../pages/database/approval/index.js")));
const AddCompany = LazyLoad(lazy(() => import("../pages/database/company/AddCompany.jsx")));
const RevisionPage = LazyLoad(lazy(() => import("../pages/presales/MasterDb/revisionData/RevisionPage.jsx")));
const ProfessionFee = LazyLoad(lazy(() => import("../pages/employee/ProfessionFee.jsx")));
const EditCompany = LazyLoad(lazy(() => import("../pages/database/company/EditCompany.js")));
const TemplateData = LazyLoad(lazy(() => import("../pages/presales/Template/index.js")));
const EmailData = LazyLoad(lazy(() => import("../pages/presales/Email/index.js")));
const AddTemplate = LazyLoad(lazy(() => import("../pages/presales/Template/AddTemplate.js")));
const LinkedinEnrichment = LazyLoad(lazy(() => import("../pages/database/linkedin/LinkedinEnrichment.js")));
const IndividualSearch = LazyLoad(lazy(() => import("../pages/presales/IndividualSearch.jsx")));
const UploadLinkedinProfiles = LazyLoad(lazy(() => import("../pages/database/linkedin/UploadLinkedinProfiles.js")));
const ContactsEngagement = LazyLoad(lazy(() => import("../pages/database/ContactsEngagement.js")));
const ContactEngagementDetail = LazyLoad(lazy(() => import("../pages/database/ContactEngagementDetail.js")));
const SendEmailWhatsapp = LazyLoad(lazy(() => import("../pages/presales/SendEmailWhatsapp/index.js")));
const AssignTempalte = LazyLoad(lazy(() => import("../pages/presales/SendEmailWhatsapp/AssignTemplate.js")));
const AssignTemplateToSend = LazyLoad(lazy(() => import("../pages/presales/SendEmailWhatsapp/AssignTemplateToSend.js")));
const CallHistory = LazyLoad(lazy(() => import("../pages/program/CallHistory/index.js")));
const WebhookEmailStatus = LazyLoad(lazy(() => import("../pages/presales/emailStatus/index.js")));

const {
  SUPERADMIN,
  ADMIN,
  PROGRAM_MANAGER,
  AGENT,
  RESOURCE_MANAGER,
  DATABASE_MANAGER,
  PRESALES_MANAGER,
  ALL,
} = constants;

const AdminRoutes = {
  path: "/app",
  element: <AdminLayout />,
  children: [
    {
      path: "/app",
      element: (
        <PrivateRoute
          element={<Dashboard path="/dashboard" />}
          requiredRole={ALL}
        />
      ),
    },
    //Resource Manager Route
    {
      path: "/app/employee-management",
      element: (
        <PrivateRoute
          element={<EmployeeManagement />}
          requiredRole={[ADMIN, RESOURCE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/attendance",
      element: (
        <PrivateRoute
          element={<AttendancePage />}
          requiredRole={{ RESOURCE_MANAGER, ADMIN, PROGRAM_MANAGER }}
        />
      ),
    },
    {
      path: "/app/add-employee",
      element: (
        <PrivateRoute
          element={<AddEmployee />}
          requiredRole={[ADMIN, RESOURCE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/edit-employee",
      element: (
        <PrivateRoute
          element={<AddEmployee />}
          requiredRole={[ADMIN, RESOURCE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/professional-fee",
      element: (
        <PrivateRoute
          element={<ProfessionFee />}
          requiredRole={[ADMIN, RESOURCE_MANAGER]}
        />
      ),
    },
    //Program Manager Route

    { path: "/app/invoice", element: <PrivateRoute element={<Invoice />} /> },
    {
      path: "/app/program1",
      element: (
        <PrivateRoute element={<Program1 />} requiredRole={[PROGRAM_MANAGER]} />
      ),
    },
    {
      path: "/app/program-management",
      element: (
        <PrivateRoute
          element={<ProgramManagement />}
          requiredRole={[PROGRAM_MANAGER]}
        />
      ),
    },

    {
      path: "/app/calling-history",
      element: (
        <PrivateRoute
          element={<CallHistory />}
          requiredRole={[PROGRAM_MANAGER]}
        />
      ),
    },
    {
      path: "/app/attendance",
      element: (
        <PrivateRoute
          element={<AttendancePage />}
          requiredRole={[PROGRAM_MANAGER]}
        />
      ),
    },

    {
      path: "/app/report",
      element: (
        <PrivateRoute
          element={<Report />}
          requiredRole={[PROGRAM_MANAGER, RESOURCE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/program-management/program-detail",
      element: (
        <PrivateRoute
          element={<ProgramDetail />}
          requiredRole={[PROGRAM_MANAGER]}
        />
      ),
    },

    {
      path: "/app/program-management/edit",
      element: (
        <PrivateRoute
          element={<EditCampaign />}
          requiredRole={[PROGRAM_MANAGER]}
        />
      ),
    },

    {
      path: "/app/presales-management",
      element: (
        <PrivateRoute
          element={<PreSalesManagement />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },
    {
      path: "/app/presales-management/add-campaign",
      element: (
        <PrivateRoute
          element={<AddCampaign />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },
    {
      path: "/app/presales-management/edit-campaign",
      element: (
        <PrivateRoute
          element={<AddCampaign />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },

    {
      path: "/app/presales-management/view-campaign",
      element: (
        <PrivateRoute
          element={<ViewCampaign />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },
    {
      path: "/app/presales-management/revision-data",
      element: (
        <PrivateRoute
          element={<RevisionPage />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },
    {
      path: "/app/template-management/send-template",
      element: (
        <PrivateRoute
          element={<SendEmailWhatsapp />}
          requiredRole={[PRESALES_MANAGER, PROGRAM_MANAGER]}
        />
      ),
    },
    {
      path: "/app/template-management/view-calling-data",
      element: (
        <PrivateRoute
          element={<AssignTemplateToSend />}
          requiredRole={[PRESALES_MANAGER, PROGRAM_MANAGER]}
        />
      ),
    },
    {
      path: "/app/template-management",
      element: (
        <PrivateRoute
          element={<TemplateData />}
          requiredRole={[PRESALES_MANAGER, PROGRAM_MANAGER]}
        />
      ),
    },

    {
      path: "/app/template-management/add-template",
      element: (
        <PrivateRoute
          element={<AddTemplate />}
          requiredRole={[PRESALES_MANAGER, PROGRAM_MANAGER]}
        />
      ),
    },
    {
      path: "/app/template-management/edit-template",
      element: (
        <PrivateRoute
          element={<AddTemplate />}
          requiredRole={[PRESALES_MANAGER, PROGRAM_MANAGER]}
        />
      ),
    },
    {
      path: "/app/email-status",
      element: (
        <PrivateRoute
          element={<WebhookEmailStatus />}
          requiredRole={[PRESALES_MANAGER, PROGRAM_MANAGER]}
        />
      ),
    },
    {
      path: "/app/whatsapp-management",
      element: (
        <PrivateRoute
          element={<EmailData />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },

    //Database Manager Route
    {
      path: "/app/database-management",
      element: (
        <PrivateRoute
          element={<DatabaseManagement />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },

    {
      path: "/app/company-management",
      element: (
        <PrivateRoute
          element={<CompanyManagement />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },

    {
      path: "/app/company-management/add-comapany",
      element: (
        <PrivateRoute
          element={<AddCompany />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/company-management/edit-comapany",
      element: (
        <PrivateRoute
          element={<EditCompany />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/approval-management",
      element: (
        <PrivateRoute
          element={<ApprovalManagement />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/add-data",
      element: (
        <PrivateRoute
          element={<AddDataToMasterDb />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },

    {
      path: "/app/individual-search",
      element: (
        <PrivateRoute
          element={<IndividualSearch />}
          requiredRole={[PRESALES_MANAGER]}
        />
      ),
    },

    {
      path: "/app/linkedin-profile-management",
      element: (
        <PrivateRoute
          element={<LinkedinEnrichment />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/linkedin-profile-management/uploadData",
      element: (
        <PrivateRoute
          element={<UploadLinkedinProfiles />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/contacts-engagement",
      element: (
        <PrivateRoute
          element={<ContactsEngagement />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },
    {
      path: "/app/contacts-engagement/detail",
      element: (
        <PrivateRoute
          element={<ContactEngagementDetail />}
          requiredRole={[DATABASE_MANAGER]}
        />
      ),
    },

    //Agent Route
    {
      path: "/app/agent-management",
      element: (
        <PrivateRoute element={<AgentManagement />} requiredRole={[AGENT]} />
      ),
    },

    {
      path: "/app/agent-management/database",
      element: (
        <PrivateRoute element={<AgentDetail />} requiredRole={[AGENT]} />
      ),
    },

    {
      path: "/app/agent-management/invoices",
      element: (
        <PrivateRoute element={<InvoicesTable />} requiredRole={[AGENT]} />
      ),
    },
    {
      path: "/app/agent-management/database/details",
      element: (
        <PrivateRoute element={<DatabaseDetail />} requiredRole={[AGENT]} />
      ),
    },
  ],
};

export default AdminRoutes;
